module.exports = __webpack_public_path__ + "static/media/TOP-NAV.438f3414.png";